import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const API = `${BASE}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also carry token in Authorization header as fallback (some browsers block 3rd-party cookies).
client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("brunner_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;

export function formatErr(detail) {
  if (detail == null) return "Ein Fehler ist aufgetreten.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function fmtEUR(n) {
  if (n === null || n === undefined || n === "") return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(n);
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  const p = (x) => String(x).padStart(2, "0");
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}
